import React, { useEffect, useState } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import { KoWorkflow, KoLoader,KoButton, KoText, KoModal, KoSearch, KoDropdown } from 'packages';
import KoIcon from '@kwapio/icons';
import { workspaceAPI } from '../workspace.service';
import WorkflowGraph from './flow';
import { DEFAULT_TEMPLATES } from './constant';
import styles from './template.module.scss';

export default function Templates({onSetTemplate, readOnly, activeTemplate, setActiveSegment: onSetActiveSegment}) {
  const [loading, setLoading] = useState(true);
  const [currentTemplate, setCurrentTemplate] = useState(activeTemplate);
  const [deleteModal,setDeleteModal] = useState(false);
  const [templates, setTemplates] = useState();
  const [activeSegment ] = useState('Edit workflow');
  const [_copyTemplate, setCopyTemplate] = useState();

  useEffect(() => {
    setLoading(true);
    getTemplates(activeTemplate?.templateId);
  }, []);

  useEffect(() => {
    onSetActiveSegment && onSetActiveSegment(activeSegment);
  }, [activeSegment]);

  useEffect(() => {
    onSetTemplate && onSetTemplate(currentTemplate);
  }, [currentTemplate]);

  const getTemplates = (id) => {
    setLoading(true);
    setCurrentTemplate(activeTemplate || DEFAULT_TEMPLATES[0]);
    const GROUPED_BY_TYPE = DEFAULT_TEMPLATES.reduce((acc, template) => {
      if (!acc[template.type]) {
        acc[template.type] = [];
      }
      acc[template.type].push(template);
      return acc;
    }, {});
    setTemplates(GROUPED_BY_TYPE);
    setCopyTemplate(GROUPED_BY_TYPE);
    setLoading(false);
  };

  const sortTemplates = ({key}) => {
    let tempList = _cloneDeep(_copyTemplate);
    let type = key;
    if(type === 'All'){
      setTemplates(_copyTemplate);
    }else {
      tempList = tempList.filter(item => item.type.includes(type));
    }
    setTemplates(tempList);
  };

  const deleteTemplate = (templateId) => {
    setLoading(true);
    workspaceAPI.deleteTemplate(templateId).then(
      (data) => {
        setDeleteModal(false);
        setLoading(false);
        getTemplates();
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const updateWorkflow = (data) => {
  };

  const action = [
    {
      label: "All templates",
      key: "All"
    },
    {
      label: "Development",
      key: "Development"
    },
    {
      label: "Marketing",
      key: "Marketing"
    },
    {
      label: "Sales",
      key: "Sales"
    },
    {
      label: "Support",
      key: "Support"
    },
    {
      label: "IT",
      key: "IT"
    },
    {
      label: "HR",
      key: "HR"
    },
    {
      label: "Orders",
      key: "Orders"
    }
  ];

  const searchUser = (value) => {
    if (value) {
      const filtered = {};
  
      Object.entries(_copyTemplate).forEach(([type, templatesArray]) => {
        const matched = templatesArray.filter(temp =>
          temp?.name?.toLowerCase().includes(value.toLowerCase())
        );
        if (matched.length > 0) {
          filtered[type] = matched;
        }
      });
  
      setTemplates(filtered);
    } else {
      setTemplates(_copyTemplate);
    }
  };
  
  return (
    <div className={styles.wrapper}>
      {loading&& <KoLoader/>}
      <div className={styles.templateWrapper}>
        <div className={styles.templateList}>
          <div className={styles.header}>
            <KoSearch placeholder={'Search templates'} allowClear onChange={e => searchUser(e.target.value)}/>
            <KoDropdown
              placement="bottomRight"
              overlayClassName={'overlayClassName'}
              menu={{
                items:action,
                onClick: sortTemplates
              }}
            >
              <KoButton type="primary" className={styles.btn} icon={<KoIcon color="#FFF" name="FilterOutlined" width={14} height={14} />}/>
            </KoDropdown>
          </div>
          <ul className={styles.paraentUl}>
            {templates && Object.entries(templates).map(([type, templateList]) => (
              <li key={type}>
                <div className={styles.typeHeader}>
                  {type}
                </div>
                <ul className={styles.ulCreate}>
                  {templateList?.map((template, index) => (
                    <li key={index} onClick={() => {onSetTemplate && onSetTemplate(template); setCurrentTemplate(template);}} className={template?.templateId === currentTemplate?.templateId  ? styles.active :''} >
                      <div  className={styles.template}>
                        <div className={styles.titleWrapper}>
                          <KoButton className={`${styles.btnsmall} ${template?.name.charAt(0).toLowerCase()}`} icon={<KoIcon color="#FFF" width={15} height={15} name={template.icon? template.icon : "FileOutlined"} />} type='primary' />
                          <KoText ellipsis={true} className={styles.title} text={template?.name} />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.workflowWrapper}>
          {/* <div className={styles.header}>
            <KoTitle level={5} className={styles.description} text="Stop wasting time on manual workflows! Speed up your process with ready-made automation templates—get started today!" />
            <KoDescription className={styles.description} text={currentTemplate?.description} />
          </div> */}
          {/* <KoSegmented onChange={setActiveSegment}  className={styles.segmented} options={['Edit workflow']} /> */}
          { activeSegment === 'Edit workflow'&&
              <div className={`${styles.workflow} tableCard`}>
                {currentTemplate&& <KoWorkflow height={500} readOnly={readOnly} isDefault={currentTemplate?.isDefault} data={currentTemplate} onChange={updateWorkflow}/>}
              </div>}
          { activeSegment === 'Workflow'  && <div className={styles.workflowTree}>
            <WorkflowGraph data={currentTemplate?.workflow}/>
          </div> }
        </div>
      </div>
      <KoModal
        title="Delete Template"
        open={deleteModal}
        handleOk={() => setDeleteModal(false)}
        width={'60rem'}
        centered
        onClose={() => {setDeleteModal(false);}}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(false)} />,
          <KoButton key='reset' danger  type='primary' label='Delete' onClick={() => deleteTemplate(currentTemplate?.templateId)} />
        ]}
      >
        <div className={styles.workflowWrapper}>
          <KoText text="Are you sure you want to delete this template?" />
        </div>
      </KoModal>
    </div>
  );
}
